import React from 'react'
import { useTranslation } from 'react-i18next'

import SelectField from '~/components/Fields/SelectField'

const options = [
  { value: null, name: 'All' },
  { value: 'active', name: 'Active' },
  { value: 'inactive', name: 'Inactive' },
]

function SupplierStatusField ({ ...props }) {
  const { t } = useTranslation()

  return (
    <SelectField
      data-cy="status"
      name="status"
      label={t('Status')}
      options={options}
      {...props}
    />
  )
}

export default SupplierStatusField
